// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7939e139","977":"28d7aac1"}[chunkId] + ".chunk.js";
};